import css from './FeaturesSection.module.css';
import { Badge, Box, Card, Container, Heading, Icon, SimpleGrid, Text } from '@chakra-ui/react';
import EmojiEmotionsRoundedIcon from '@mui/icons-material/EmojiEmotionsRounded';
import CardMembershipRoundedIcon from '@mui/icons-material/CardMembershipRounded';
import ForumRoundedIcon from '@mui/icons-material/ForumRounded';
import ContactPageRoundedIcon from '@mui/icons-material/ContactPageRounded';
import MyLocationRoundedIcon from '@mui/icons-material/MyLocationRounded';
import PaymentsRoundedIcon from '@mui/icons-material/PaymentsRounded';

const FeaturesSection = () => {
  const features = [
    {
      title: 'Location-based search',
      icon: <MyLocationRoundedIcon />,
      content:
        'Find gyms, personal trainers, fitness classes, and sports clubs near you — with precise location results and interactive maps.',
    },
    {
      title: 'Search by vibe',
      icon: <EmojiEmotionsRoundedIcon />,
      content: 'Explore places by the energy and atmosphere you prefer, using simple vibe tags.',
    },
    {
      title: 'Detailed profiles',
      icon: <ContactPageRoundedIcon />,
      content: 'View comprehensive profiles with photos, amenities, pricing, schedules, and more.',
    },
    {
      title: 'Price comparison',
      icon: <PaymentsRoundedIcon />,
      content:
        'Compare membership prices, class packages, and training rates to find the best value for your budget.',
    },
    {
      title: 'No membership',
      icon: <CardMembershipRoundedIcon />,
      content:
        "Filter for classes and gyms that don't need membership — ideal for drop-ins or trying something new.",
    },
    {
      title: 'Direct messaging',
      icon: <ForumRoundedIcon />,
      content:
        'Connect directly with trainers and facility managers to ask questions and schedule consultations.',
    },
  ];

  return (
    <section className={css.featuresWrapper}>
      <Container maxW={'5xl'}>
        <Badge size="md" colorPalette="purple" variant="surface">
          Features
        </Badge>
        <Heading
          size={{
            base: '3xl',
            lg: '5xl',
          }}
          fontWeight={'bold'}
          className={css.featuresHeading}
        >
          Everything nearby, made easy
        </Heading>
        <Text
          fontSize={{
            base: 'md',
            lg: 'lg',
          }}
          fontWeight="medium"
          color={'lightGreyText'}
          styles={{ mb: '3rem' }}
        >
          Discover, compare, and connect with the best fitness facilities and professionals in your
          area.
        </Text>
        <SimpleGrid columns={{ base: 3, mdDown: 1 }} gap="1.5rem">
          {features.map(feature => (
            <Card.Root
              key={feature.title}
              variant={'elevated'}
              colorPalette={'purple'}
              style={{ borderRadius: '1em' }}
            >
              <Card.Header>
                <div>
                  <Box p="1em" bg="brand.50" borderRadius="0.5em" display="inline-block">
                    <Icon size="xl" color={'brand.900'} boxSize="1em">
                      {feature.icon}
                    </Icon>
                  </Box>
                </div>
              </Card.Header>
              <Card.Body className={css.featureContent}>
                <Heading
                  size={{
                    base: 'sm',
                    lg: 'md',
                  }}
                  fontWeight={'bold'}
                  as={'h4'}
                  mt={'0.5rem'}
                  mb={0}
                >
                  {feature.title}
                </Heading>
                <Text
                  fontSize={{
                    base: 'sm',
                    lg: 'md',
                  }}
                  mt={0}
                >
                  {feature.content}
                </Text>
              </Card.Body>
            </Card.Root>
          ))}
        </SimpleGrid>
      </Container>
    </section>
  );
};

export default FeaturesSection;
